import React from "react";
import { useMachine } from "@xstate/react";
import { Machine, assign } from "xstate";

import Step1 from "../Step1";
import Step2 from "../Step2";
import Step3 from "../Step3";
import Step4 from "../Step4";
import Step5 from "../Step5";
import StepsComplete from "../StepsComplete";
import Button from "../Button";

const Welcome = ({ onSubmit }) => (
  <div style={{ textAlign: "center" }}>
    <h1>List Your Equipment On DADE Auctions</h1>
    <Button onClick={onSubmit}>Click here to continue</Button>
  </div>
);

const getWizardMachine = () => {
  const config = {
    id: "wizard",
    initial: "welcome",
    on: {
      WELCOME_COMPLETE: {
        target: "step1",
      },
    },
    states: {
      welcome: {},
      step1: {
        on: {
          STEP1_COMPLETE: {
            target: "step2",
            actions: "assignStep1",
          },
        },
      },
      step2: {
        on: {
          STEP2_COMPLETE: {
            target: "step3",
            actions: "assignStep2",
          },
          GO_BACK: {
            target: "step1",
            actions: "assignStep2",
          },
        },
      },
      step3: {
        on: {
          STEP3_COMPLETE: {
            target: "step4",
            actions: "assignStep3",
          },
          GO_BACK: {
            target: "step2",
            actions: "assignStep3",
          },
        },
      },
      step4: {
        on: {
          GO_BACK: {
            target: "step3",
            actions: "assignStep4",
          },
          STEP4_COMPLETE: {
            target: "step5",
            actions: "assignStep4",
          },
        },
      },
      step5: {
        on: {
          STEP5_COMPLETE: {
            target: "end",
            actions: "assignStep5",
          },
          GO_BACK: {
            target: "step4",
            actions: "assignStep5",
          },
        },
      },
      end: {},
    },
  };

  const machine = Machine(config as any, {
    actions: {
      assignStep1: assign(
        (context, { firstName, lastName, email, phoneNumber }: any) => ({
          step1: {
            firstName,
            lastName,
            email,
            phoneNumber,
          },
        })
      ),
      assignStep2: assign((context, { type, ...data }) => ({
        step2: data,
      })),
      assignStep3: assign((context, { type, ...data }) => ({
        step3: data,
      })),
      assignStep4: assign((context, { type, ...data }) => ({
        step4: data,
      })),
      assignStep5: assign((context, { type, ...data }) => ({
        step5: data,
      })),
    },
  });

  return machine;
};

export default function Wizard() {
  const [current, send] = useMachine(getWizardMachine());

  if (current.matches("welcome")) {
    return (
      <Welcome
        onSubmit={() => {
          send("WELCOME_COMPLETE");
        }}
      />
    );
  }

  const step1 =
    (current as any).context && (current as any).context.step1
      ? (current as any).context.step1
      : {};
  if ((current as any).matches("step1")) {
    return (
      <Step1
        {...step1}
        onSubmit={(values) => {
          send("STEP1_COMPLETE", values);
        }}
      />
    );
  }

  const step2 =
    (current as any).context && (current as any).context.step2
      ? (current as any).context.step2
      : {};

  if ((current as any).matches("step2")) {
    return (
      <Step2
        {...step2}
        onBack={(values) => {
          send("GO_BACK", values);
        }}
        onSubmit={(values) => {
          send("STEP2_COMPLETE", values);
        }}
      />
    );
  }

  const step3 =
    (current as any).context && (current as any).context.step3
      ? (current as any).context.step3
      : {};

  if ((current as any).matches("step3")) {
    return (
      <Step3
        {...step3}
        onBack={(values) => {
          send("GO_BACK", values);
        }}
        onSubmit={(values) => {
          send("STEP3_COMPLETE", values);
        }}
      />
    );
  }

  const step4 =
    (current as any).context && (current as any).context.step4
      ? (current as any).context.step4
      : {};

  if ((current as any).matches("step4")) {
    return (
      <Step4
        {...step4}
        onBack={(values) => {
          send("GO_BACK", values);
        }}
        onSubmit={(values) => {
          send("STEP4_COMPLETE", values);
        }}
      />
    );
  }

  const step5 =
    (current as any).context && (current as any).context.step5
      ? (current as any).context.step5
      : {};

  if ((current as any).matches("step5")) {
    return (
      <Step5
        {...step5}
        onBack={(values) => {
          send("GO_BACK", values);
        }}
        onSubmit={(values) => {
          send("STEP5_COMPLETE", values);
        }}
      />
    );
  }

  return <StepsComplete data={(current as any).context} />;
}
